import React, { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import BarcodeScanner from "../components/BarcodeScanner";
import "../styles/scanner.css";

interface Row { value: string; ok: boolean }

let audio: AudioContext | null = null;
function beep() {
  try {
    const ac: AudioContext = audio ?? new ((window as any).AudioContext || (window as any).webkitAudioContext)();
    audio = ac;
    if (ac.state === "suspended") ac.resume();
    const o = ac.createOscillator();
    const g = ac.createGain();
    o.frequency.value = 1040;
    g.gain.value = 0.15;
    o.connect(g); g.connect(ac.destination);
    o.start(); o.stop(ac.currentTime + 0.09);
  } catch { /* звук не критичен */ }
}

/** Страница на телефоне: открывается по QR из CRM, входа в аккаунт не требует (доступ по секретному коду в ссылке) */
export default function ScanPhonePage() {
  const { code = "" } = useParams();
  const [started, setStarted] = useState(false);
  const [dead, setDead] = useState(false);
  const [rows, setRows] = useState<Row[]>([]);
  const alive = useRef(true);

  // раз в несколько секунд сообщаем компьютеру, что телефон на связи; заодно узнаём, не устарело ли подключение
  useEffect(() => {
    alive.current = true;
    const ping = () => fetch(`/api/scanner/ping?code=${encodeURIComponent(code)}`).then((r) => { if (alive.current && r.status === 404) setDead(true); }).catch(() => undefined);
    ping();
    const t = setInterval(ping, 8000);
    return () => { alive.current = false; clearInterval(t); };
  }, [code]);

  const send = useCallback(async (value: string) => {
    beep();
    try {
      const r = await fetch("/api/scanner/push", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ code, value }) });
      if (r.status === 404) setDead(true);
      setRows((p) => [{ value, ok: r.ok }, ...p].slice(0, 5));
    } catch {
      setRows((p) => [{ value, ok: false }, ...p].slice(0, 5));
    }
  }, [code]);

  if (dead) {
    return (
      <div className="scp">
        <h1>Подключение устарело</h1>
        <p>Откройте CRM на компьютере, нажмите «Сканер» и отсканируйте новый QR-код.</p>
      </div>
    );
  }

  if (!started) {
    return (
      <div className="scp">
        <h1>📱 Сканер для CRM</h1>
        <p>Нажмите «Начать» и разрешите доступ к камере. Коды будут появляться на компьютере в открытом поле CRM.</p>
        <button className="scp-btn" onClick={() => { beep(); setStarted(true); }}>Начать сканирование</button>
      </div>
    );
  }

  return (
    <BarcodeScanner
      continuous
      title="Сканируйте: код уйдёт на компьютер"
      closeLabel="Стоп"
      onDetected={send}
      onClose={() => setStarted(false)}
      footer={
        <div className="scp-log">
          {rows.length === 0 ? <div className="hint">Здесь появятся отправленные коды</div> : rows.map((r, i) => (
            <div key={i} className={r.ok ? "" : "bad"}>{r.ok ? "✓" : "✗ не отправлен"} <b>{r.value}</b></div>
          ))}
        </div>
      }
    />
  );
}
